import { memo } from 'react';
import { useSelector } from 'react-redux';

import Global from '../../../../store/global-selectors';
import { useLocale } from '../../../../intl/hooks';

const zero = 0;
const escapedMdash = '\u2014'; // escaped Unicode "—" character

const currency = 'currency';
const literal = 'literal';

const TypesToPersist = {
  currency,
  literal,
};

const numberFormatOptions = {
  style: currency,
  currencyDisplay: 'narrowSymbol',
};

export const EmptyRateDisplayValue = memo(() => {
  const sellerDefaultCurrencyCode = useSelector(Global.selectSellerDefaultCurrency);
  const { locale } = useLocale();

  const numberFormat = new Intl.NumberFormat(locale, {
    currency: sellerDefaultCurrencyCode,
    ...numberFormatOptions,
  });
  const parts = numberFormat.formatToParts(zero);
  const currencyPart = parts.find((part) => part.type === currency);

  // the locale will determine if the result will be '€0,00' or '0,00 €'
  // and we'll need to respect the positioning of the currency symbol
  const currencyIndex = parts.indexOf(currencyPart);

  // remove the zero(s) and any decimal/comma so that we only end up
  // with a currency symbol and whitespace character
  const filteredParts = parts
    .reduce((acc, part) => {
      if (TypesToPersist[part.type]) {
        acc.push(part.value);
      }

      return acc;
    }, [])
    .join('');

  const displayValue = currencyIndex > 0 ? `${escapedMdash + filteredParts}` : `${filteredParts + escapedMdash}`;

  return displayValue;
});
